import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import Button from "../../coraWebComponents/buttons/Button";
import Checkbox from "../../coraWebComponents/forms/Checkbox";
import Upload from '../../coraWebComponents/forms/Upload';
import Tooltip from "../../coraWebComponents/forms/Tooltip";
import { buildUrl } from "../../coraWebComponents/utils/helper";
import withRouter from "../../coraWebComponents/utils/withRouter";
import { showMsg } from '../../coraWebComponents/utils/logger';

// proptypes
import ziadostPropTypes from "../../propTypes/ziadostPropTypes";

// components
import Grid from "../../coraWebComponents/dataGrid/DataGrid";
import flags from "../../coraWebComponents/utils/flags";

// actions
import * as filesActions from "../../actions/filesActions";
import * as vyjadrenieActions from "../../actions/vyjadrenieActions";

import _ from "lodash";

const DownloadBtn = (props) => {
  const { dataItem, downloadReportInDocx, ziadost } = props;
  const reportName = dataItem["NAME"];
  const I_AG_ZIADOST = ziadost.I_AG_ZIADOST;
  return (
    <Button
      imageUrl={buildUrl("assets/notify_stiahnut.svg")}
      onClick={async () => await downloadReportInDocx(reportName, I_AG_ZIADOST)}
    />
  );
};
const CheckBox = (props) => {
  const { dataItem, onChange } = props;
  return <Checkbox name={dataItem["NAME"]} value={dataItem["L_CHECK"]} onChange={onChange} />;
};

class Dokumenty extends React.Component {
  constructor(props) {
    super(props);
    const dokumenty = props.vyjadrenie?.dokumenty;

    this.state = {
      prilohy: dokumenty ? dokumenty.prilohy : [],
      filesNames: dokumenty ? dokumenty.filesNames : [],
      reportsNames: dokumenty ? dokumenty.reportsNames : [],
    };
  }

  reverseString = (str) => {
    return str === "" ? "" : this.reverseString(str.substr(1)) + str.charAt(0);
  };
  removeMimeType = (f) => {
    const f1NameReversed = this.reverseString(f);
    return f1NameReversed.substr(
      f1NameReversed.indexOf("."),
      f1NameReversed.length - 1
    );
  };
  areFileNamesEquals = (f1, f2) => {
    f1 = this.removeMimeType(f1);
    f2 = this.removeMimeType(f2);
    return f1 === f2;
  };
  saveData = async () => {
    const { reportsNames, prilohy, filesNames } = _.cloneDeep(this.state);

    const data = {
      prilohy,
      filesNames,
      reportsNames: reportsNames.map(x => {
        return {
          ...x,
          L_CHECK: x.L_CHECK && !filesNames.map(x => this.removeMimeType(x)).includes(this.removeMimeType(x.NAME))
        }
      })
    };

    this.props.ulozData({ dokumenty: data });
  };
  handleOnChangeCheckBox = (fileName, value) => {
    const reportsNames = this.state.reportsNames.map(x => { return x.NAME === fileName ? { ...x, L_CHECK: value } : x });
    this.setState({ reportsNames });
  };
  genSchema = () => {
    return [
      {
        field: "L_CHECK",
        title: " ",
        filter: "cmd",
        cell: (props) => (
          <CheckBox
            {...this.props}
            {...props}
            onChange={this.handleOnChangeCheckBox}
          />
        ),
      },
      {
        field: "NAME",
        title: "Názov",
        width: "auto",
      },
      {
        field: "L_BD",
        title: "Stiahnuť",
        filter: "cmd",
        width: 100,
        cell: (props) => <DownloadBtn {...this.props} {...props} />,
      },
    ];
  };

  deleteFile = (index) => {
    const filesNames = this.state.filesNames.filter((item, i) => i !== index);
    const prilohy = this.state.prilohy.filter((item, i) => i !== index);
    this.setState({ prilohy: prilohy, filesNames: filesNames });
  };
  handleOnChangeUpload = async (name, files) => {
    const maxNameLength = 100;
    const modified = files.filter(f => f.name.length > maxNameLength).map(f => f.name);
    const mFiles = await Promise.all(
      files.map(async (f) => {
        const rawFile = await f.getRawFile();
        const name = f.name.length > maxNameLength ? f.name.replace(f.extension, "").substr(0, maxNameLength - f.extension.length) + f.extension : f.name;
        return { name: name, rawFile: rawFile }
      })
    );
    if (modified.length > 0) {
      this.props.showMsg("Vybraným súborom (" + modified.length + ") bol orezaný názov na " + maxNameLength + " znakov.");
    }
    const prilohyOld = this.state.prilohy;
    const fileNamesOld = this.state.filesNames;
    const filesNames = [...fileNamesOld, ...mFiles.filter(f => !fileNamesOld.includes(f.name)).map(f => f.name)];
    const prilohy = [...prilohyOld, ...mFiles.filter(f => !fileNamesOld.includes(f.name)).map(f => f.rawFile)];
    this.setState({ prilohy: prilohy, filesNames: filesNames });
  };

  // system methods
  componentDidMount = async () => {
    const { getReportsNames, setRef } = this.props;

    setRef(this);
    if (this.state.reportsNames.length === 0) {
      await getReportsNames();
      this.setState({ reportsNames: this.props.reportsNames });
    }
  };
  render() {
    const { className, cancel, moveNext, moveBack, isLoading, onKeyDown, index, ziadost } = this.props;
    const { filesNames } = this.state;
    const reportsNames = this.state.reportsNames;

    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <div className={`row m-0 ${className}`}>
        <div className={media.matches ? "col-8 offset-2 p-0 forWeb" : "col p-0 forMobile"}>
          <div className="card formular">
            <div className="form-body">
              {/* FORM */}
              <Tooltip>
                <form
                  id={`webForm${index}`}
                  className="k-form"
                  onSubmit={moveNext}
                  onKeyDown={onKeyDown}
                >
                  <div className="card-title">
                    <div>Prílohy a komentáre ku žiadosti {ziadost.KOD_ZIADOSTI}</div>
                  </div>
                  <Grid
                    data={reportsNames}
                    isLoading={isLoading}
                    onChange={() => { }}
                    onGet={() => { }}
                    onGetList={() => { }}
                    primaryField="NAME"
                    schema={this.genSchema()}
                    total={reportsNames.length}
                    disabled={flags.PAGING | flags.FILTER | flags.SORT}
                    allColumns
                    fixedFilter={{filters:[]}}
                    initSort={[]}
                    onChangeField={() => { }}
                    onCancel={() => { }}
                    updateSort={() => { }}
                    filter={{filters:[]}}
                    sort={[]}
                    page={{ skip: 0, take: reportsNames.length }}
                    hidden={flags.ADD | flags.COPY | flags.CANCEL | flags.PRINT | flags.RESET | flags.TOOLBAR |
                      flags.EDIT | flags.COLUMN_MENU | flags.COLUMN_SELECTED | flags.EDITALL | flags.GRID_CELL_EDIT | flags.USER_FILTER | flags.DETAIL}  
                    hiddenBack  
                  />
                  <div className="k-form-field">
                    <span>{"Prílohy"}</span>
                    <Upload
                      name={"prilohy"}
                      onChange={this.handleOnChangeUpload}
                      value={null}
                      url={"x"}
                      restrictions={{
                        allowedExtensions: [],
                      }}
                      autoUpload={false}
                      multiple={true}
                      showActionButtons={true}
                      requiredMaximumSize={"1MB"}
                      tab-index={1}
                    />
                  </div>

                  <p>&nbsp;</p>
                  <div style={{ fontWeight: "bold" }}>Vybraté prílohy:</div>
                  {filesNames.map((fileName, i) => (
                    <div key={i} className="file-item row">
                      <div className="col-10">{fileName}</div>
                      <div className="col-2">
                        <Button key={i} primary iconClass="k-icon k-font-icon k-i-close" onClick={(e) => { this.deleteFile(i); }} />
                      </div>
                    </div>
                  ))}

                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button primary label="Zrusiť" onClick={cancel} />
                    <div className="flexGroup">
                      <Button primary label="Späť" onClick={moveBack} />
                      <Button primary label="Ďalej" onClick={moveNext} type="submit" />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ziadost: state.ziadost.data,
    reportsNames: state.reports.names,
    isLoading: state.reports.isLoading || state.files.isLoading,
    vyjadrenie: state.vyjadrenie.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getReportsNames: () => dispatch(filesActions.getReportsNames()),
  downloadReportInDocx: (reportName, I_AG_ZIADOST) => dispatch(filesActions.downloadReport(reportName, I_AG_ZIADOST)),
  ulozData: (data) => dispatch(vyjadrenieActions.ulozData(data)),
  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))
});

Dokumenty.propTypes = {
  setRef: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  ulozData: PropTypes.func,
  ziadost: ziadostPropTypes.ziadost,
  downloadReportInDocx: PropTypes.func,
  reportsNames: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Dokumenty)
);
